import React, { useEffect } from "react";
import BaseLayout from "../../components/BaseLayout";
import HeaderBaseLayout from "../../components/HeaderBaseLayout";
import NoQuiz from "../QuizPage/NoQuiz";
import * as Assets from "../../utils/svg_assets";
import * as PageRoutes from "../../utils/route_pages";
import { Col, Row, Card } from "react-bootstrap";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { differenceDateUntilNow } from "../../utils/utilities";
import "./style.scss";

const SurveyStart = (props) => {
  const navigate = useNavigate();
  const { pwa_setting, getSurveyList, surveyList } = props;

  const handleButtonAction = (id) => {
    navigate(PageRoutes.survey + `/${id}`);
  };

  useEffect(() => {
    getSurveyList();
  }, []);

  return (
    <BaseLayout
      show_menu={pwa_setting.show_main_menu}
      isCustom={true}
      header={
        <HeaderBaseLayout
          src={Assets.iconBackWhite}
          title="Survey"
          onClick={() => navigate(PageRoutes.home)}
        />
      }
    >
      <Row className="survey-content">
        {surveyList.length > 0 ? (
          surveyList &&
          surveyList.map((a, index) => (
            <Col
              xs={12}
              sm={12}
              md={12}
              className="content-wrapper"
              key={index}
            >
              <Card className="card-category">
                <div className="card-top">
                  <img src={Assets.iconSurvey} alt="logo_image" />
                  <div className="title-wrapper">
                    <span className="title">{a.name}</span>
                  </div>
                </div>
                <Row className="pt-1">
                  <Col xs={7} sm={7} md={7}>
                    <div className="card-details">
                      <img src={Assets.iconGoldCoin} alt="logo_image" />
                      <div className="point-wrapper">
                        <span className="point">
                          Get {a.points} {a.currency.name}
                        </span>
                      </div>
                    </div>
                    <div className="card-bottom-left">
                      <span className="text">
                        {a.is_completed
                          ? "You have filled survey"
                          : `Posted by ${a.creator}`}
                      </span>
                    </div>
                  </Col>
                  <Col xs={5} sm={5} md={5} className="text-center">
                    <div
                      className={`btn btn-sm btn-action ${
                        a.is_completed ? "inactive" : ""
                      }`}
                      onClick={() => handleButtonAction(a.id)}
                    >
                      {a.is_completed ? "Completed" : "Fill Survey"}
                    </div>
                    <div className="card-bottom-right">
                      <span className="text">
                        {differenceDateUntilNow(a.start)} days ago
                      </span>
                    </div>
                  </Col>
                </Row>
              </Card>
            </Col>
          ))
        ) : (
          <NoQuiz title="survey" />
        )}
      </Row>
    </BaseLayout>
  );
};

const mapStateToProps = (state) => ({
  pwa_setting: state.LoginSM.login.organization_pwa_settings,
  surveyList: state.SurveySM.surveyList,
});

const mapDispatchToProps = (dispatch) => ({
  getSurveyList: dispatch.SurveySM.getSurveyList,
});

export default connect(mapStateToProps, mapDispatchToProps)(SurveyStart);
